import { lazy } from 'react';
import { Loadable } from '../../loadable/components/Loadable';

export const AsyncModelsPage = Loadable({
  Component: lazy(() =>
    import('./ModelsPage').then((mod) => ({
      default: mod.ModelsPage,
    }))
  ),
});
